import API from 'services/api';

export const getCustomerSettings = (userId: number) => API.get(`/api/users/${userId}/settings`);
